import { apiClient } from './client'
import type { ApiResponse } from './client'
import type { WorkspaceEmailActivityDto } from '@/types/emailActivity'

export interface EmailActivityListOpts {
    status?: string
    type?: string
    search?: string
    from?: string
    to?: string
    skip?: number
    take?: number
    signal?: AbortSignal
}

// Workspace email-activity list (ORB-385): the operational queue/triage of sends to people, plus the
// armed-broadcasts band on the Upcoming filter. Status/type are validated server-side (an unknown value
// is a 400, surfaced via ApiResponse.error). Accepts an AbortSignal so rapid filter/search/paging cancels
// the superseded request.
export const emailActivityApi = {
    list: (workspaceId: string, opts: EmailActivityListOpts = {}): Promise<ApiResponse<WorkspaceEmailActivityDto>> => {
        const query = new URLSearchParams()
        if (opts.status) query.set('status', opts.status)
        if (opts.type) query.set('type', opts.type)
        if (opts.search) query.set('search', opts.search)
        if (opts.from) query.set('from', opts.from)
        if (opts.to) query.set('to', opts.to)
        if (opts.skip != null) query.set('skip', String(opts.skip))
        if (opts.take != null) query.set('take', String(opts.take))
        const qs = query.toString()
        return apiClient.get(
            `/api/Workspaces/${workspaceId}/Email/Activity${qs ? `?${qs}` : ''}`,
            { signal: opts.signal },
        )
    },
}
